import * as React from "react";
import * as models from "app/models/requireme";
import * as kea from "kea-react";
import * as resources from "app/resources/index";
import * as selectores from "app/features/selectores/index";
import * as history from "app/main/history";
import { Route, Redirect, withRouter, match } from "react-router";
import { createSelectorRx } from "keautils";
import { validation, formfields, Checkbox } from "kea-react"
import { fa } from "typed-font-awesome";
import { componentToRx } from "app/logic/rx";
import { observeResource } from "kea-resource";

type Entity = models.FiltroReporteSaldosCart;
export interface State {
    value: Entity;
}

/**
* Componente para editar un Entity
*/
export class ReporteSaldosCartera extends React.PureComponent<{}, State> {
    constructor(props) {
        super(props);
        this.state = {
            value: {} as Entity
        };
    }

    errors = () => validation.getErrors(this.rules, this.state.value);
    getField = formfields(() => ({
        value: this.state.value,
        onChange: (x: Entity) => this.setState({ value: x })
    }), this.errors);

    get rules(): validation.Rules<Entity> {
        return {
            FechaCorte: validation.required,
        };
    }

    onGenerarSaldoCartera = async () => {
        const reporte = await resources.RepSaldoCartera.GenerarSaldosCart(this.state.value);
        await kea.download(reporte, "Saldo cartera.xls");
    }

    onGenerarNotasCredito = async () => {
        const reporte = await resources.RepSaldoCartera.GenerarNotasCredito(this.state.value);
        await kea.download(reporte, "Notas credito.xls");
    }

    onGenerarNotasCargo = async () => {
        const reporte = await resources.RepSaldoCartera.GenerarNotasCargo(this.state.value);
        await kea.download(reporte, "Notas de cargo.xls");
    }

    render() {
        const getField = this.getField;
        const DateTime = getField(kea.DateTime);
        const Sucursal = getField(selectores.Sucursal);
        const Cliente = getField(selectores.Cliente);
        return (
            <div>
                <kea.Title titulo="Reporte de saldos de cartera" onRegresar={() => history.go("../")} />
                {kea.autogrid(4, [
                    <DateTime field="FechaCorte" label="Fecha de corte" />,
                    <Cliente field="IdCliente" label="Cliente" />,
                    <Sucursal field="IdSucursal" label="Sucursal" />
                ])}
                <div className="row">
                    <div className="col-md-12">
                        <div className="btn-group">
                            <kea.Button children="Saldo cartera" style="success" onClick={this.onGenerarSaldoCartera} disabled={validation.hasError(this.errors())} />
                            <kea.Button children="Notas de crédito" style="success" onClick={this.onGenerarNotasCredito} disabled={validation.hasError(this.errors())} />
                            <kea.Button children="Notas de cargo" style="success" onClick={this.onGenerarNotasCargo} disabled={validation.hasError(this.errors())} />
                        </div>
                    </div>
                </div>
            </div>);
    }
}



// WEBPACK FOOTER //
// ./app/features/general/operativa/items/reportesaldocartera/index.tsx